import cn from 'classnames'
import { TopAppBar, TopAppBarProps } from '../TopAppBar'
import { useIsMobile } from 'hooks/useIsResponsive'
import LoadingPage from '../LoadingPage'
import ErrorPageComponent from '../ErrorPageComponent'
import { Box } from 'components/Material'
import { MainContainer } from '../MainContainer'

interface ContainerImageProps extends TopAppBarProps {
  children: React.ReactNode
  className?: string
  bgColor?: 'white' | 'dark'
  isErrorPage?: boolean
  isPageLoading?: boolean
  refetchPage?: () => void
}

const ContainerImage = ({
  children,
  className,
  isErrorPage = false,
  isPageLoading = false,
  refetchPage,
  ...propsTopAppBar
}: ContainerImageProps) => {
  const isMobile = useIsMobile()
  const bgColor = !isMobile ? 'dark' : 'white'
  const containerStyles = {
    'flex w-screen h-[calc(100vh-64px)] bottom-0': !isMobile || isMobile,
    'bg-black': bgColor === 'dark',
    'bg-gray-10': bgColor === 'white',
    'fixed overflow-hidden ': true
  }

  return (
    <>
      <TopAppBar
        {...propsTopAppBar}
        themeColor="white"
        rightIcon="close"
        typographyLeftPadding={isMobile ? '20px' : '50px'}
      />

      <Box className={cn(containerStyles, className)}>
        <MainContainer bgColor={bgColor} isSidebarOpen={false} showButton={false}>
          {isErrorPage ? (
            <ErrorPageComponent refetchpage={refetchPage} />
          ) : isPageLoading ? (
            <LoadingPage />
          ) : (
            children
          )}
        </MainContainer>
      </Box>
    </>
  )
}

export default ContainerImage
